module.exports = __webpack_public_path__ + "static/Max&ProgramPreview-e05ebfc9e041c3e529fb96baa7a421b6.png";